module.exports = __webpack_public_path__ + "img/9788930086844.f2d86c76.jpg";